/**
 * iter-221f — Lightweight client telemetry helper.
 *
 * Posts events to the internal /api/telemetry/track endpoint. The
 * server stamps vendor_id / user_id from the auth token, so the
 * client cannot fake identity. Failures are swallowed — telemetry
 * MUST NEVER break the user-facing flow.
 *
 * Usage:
 *   import { track } from '@/lib/telemetry';
 *   track('trial_gate_hit', { gate: 'trial_expired', reason: 'no_subscription' });
 */

const SESSION_KEY = 'aniyor_telemetry_session_id';

function getSessionId() {
  try {
    let sid = sessionStorage.getItem(SESSION_KEY);
    if (!sid) {
      sid =
        (window.crypto && typeof window.crypto.randomUUID === 'function')
          ? window.crypto.randomUUID()
          : `s_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
      sessionStorage.setItem(SESSION_KEY, sid);
    }
    return sid;
  } catch {
    return null;
  }
}

export async function track(name, props) {
  try {
    const backend = process.env.REACT_APP_BACKEND_URL;
    if (!backend) return;
    const token =
      localStorage.getItem('aniyor_token') ||
      localStorage.getItem('access_token') ||
      localStorage.getItem('token');
    if (!token) return; // not logged in — skip
    await fetch(`${backend}/api/telemetry/track`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      keepalive: true,  // survives page unload (e.g. nav after the redirect)
      body: JSON.stringify({
        name,
        session_id: getSessionId(),
        props: props || {},
      }),
    });
  } catch {
    // intentionally silent
  }
}
